export const SET_TOKEN = 'SET_TOKEN'

export const APP_LOAD_BEGIN = 'APP_LOAD_BEGIN'
export const APP_LOAD_SUCCESS = 'APP_LOAD_SUCCESS'
export const APP_LOAD_ERROR = 'APP_LOAD_ERROR'

export const APP_MERGE_OBJECT = 'APP_MERGE_OBJECT'

export const UPDATE_COMPANY_BEGIN = 'UPDATE_COMPANY_BEGIN'
export const UPDATE_COMPANY_SUCCESS= 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_ERROR= 'UPDATE_COMPANY_ERROR'

export const SHOW_FORM = 'SHOW_FORM'
export const HIDE_FORM = 'HIDE_FORM'

export const SHOW_DELETE_POPUP = 'SHOW_DELETE_POPUP'
export const HIDE_DELETE_POPUP = 'HIDE_DELETE_POPUP'

export const SET_FORM_DATA = 'SET_FORM_DATA'